import React from "react"
import { dataLayerPush, storeUserInformation } from "../functions/data-layer"

const Tracking = ({ location }) => {
    React.useEffect(() => {
        const userId = storeUserInformation("get", "user-id")
        const email = storeUserInformation("get", "email")
        const phone = storeUserInformation("get", "phone")
        if (userId) dataLayerPush("set_user_id", {user_id: userId})
        if (email) dataLayerPush("set_user_email", {email: email})
        if (phone) dataLayerPush("set_user_phone", {phone: phone})
    }, [location])
    return <></>
}

export default Tracking